import { Label, Tooltip, UIHeading4, UIText2 } from '@cian/ui-kit';

import { type FC } from 'react';

import { useCAForCard } from '@/microfrontends/listing/shared/hooks/card/useCAForCard';

import { Link } from '@/packages/shared-ui';
import { stopPropagation } from '@/packages/utils/event/stopPropagation';

import { TooltipContent } from '../../components/TooltipContent';

export const CoworkingsBenefitsLabelContainer: FC = () => {
  const ca = useCAForCard();

  return (
    <Tooltip
      arrow={false}
      placement="bottom"
      theme="white"
      title={
        <TooltipContent>
          <UIHeading4>Коворкинг на 38% дешевле</UIHeading4>
          <TooltipContent.Description>
            <UIText2>Аренда коворкинга в первый год выгоднее обычного офиса</UIText2>
          </TooltipContent.Description>
          <Link
            href="https://promo.cian.ru/coworking"
            track={() => ca({ action: 'click_sopr', category: 'Listing', label: 'profitably' })}
            onClick={stopPropagation}
          >
            Подробный разбор
          </Link>
        </TooltipContent>
      }
    >
      <Label
        background="surface-negative-default"
        color="text-negative-default"
        data-testid="publisher-labels.coworkings-benefits"
      >
        Это выгодно
      </Label>
    </Tooltip>
  );
};
